import { defineComponent } from "vue";
import { mapState } from "pinia";

import { useConvertToPendingPal } from "../../../store/useConvertToPendingPal";

import FormSection from "../../../../../../resources-vue/vue-custom-elements/FormSection/FormSection.vue";
import PatientPharmacy from "../PatientPharmacy/PatientPharmacy.vue";

export default defineComponent({
    components: {
        FormSection,
        PatientPharmacy
    },
    computed: {
        ...mapState(useConvertToPendingPal, ["patientDetails", "patientOptions"])
    },
    mounted() {
        if (!this.patientDetails.pharmacyAndDme.pharmacies?.length) {
            this.patientDetails.pharmacyAndDme.pharmacies = [null];
        }
    },
    methods: {
        addNewPharmacy() {
            this.patientDetails.pharmacyAndDme.pharmacies = this.patientDetails.pharmacyAndDme.pharmacies.concat(null);
        }
    }
});
